(function() {
  'use strict';

  angular.module('app').controller('BusinessStaffController', BusinessStaffController);

  BusinessStaffController.$inject = [
    '$scope', '$rootScope', '$route', '$routeParams', '$location', '$timeout', '$filter', '$translate',
    'blockUI', '$uibModal', 'BusinessStaffService', 'SelectService', 'NotifyService', 'ExportService'];

  function BusinessStaffController($scope, $rootScope, $route, $routeParams, $location, $timeout, $filter, $translate,
      blockUI, $uibModal, BusinessStaffService, SelectService, NotifyService, ExportService) {
    $scope.data = {
      suspendedTypes: [
        {id: 'all', title: 'All'},
        {id: 'yes', title: 'Yes'},
        {id: 'no', title: 'No'}
      ],
      registerTypes: [
        {id: 'register', title: 'TEXT_MODE_REGISTER'},
        {id: 'steward', title: 'TEXT_MODE_STEWARD'},
        {id: 'validator', title: 'TEXT_MODE_VALIDATOR'},
        {id: 'prepaid-services', title: 'TEXT_MODE_PREPAID_SERVICES'},
        {id: 'road-tanker-driver', title: 'TEXT_MODE_ROAD_TANKER_DRIVER'},
        {id: 'kiosk', title: 'TEXT_MODE_KIOSK'}
      ],
      staff_terminal: {}
    };
    $scope.getFiltersList = SelectService.getLPRList;
    $scope.getPages = getTotalPaginatedPages;
    $scope.staff = {};

    $scope.hasTerminal = function(terminal) {
      return !!$scope.staff.terminals.find(function(t) {
        return t.id === terminal.id && t.filter_list_type === 'register';
      });
    };
    $scope.removeTerminalToStaff = function(index) {
      $scope.staff.terminals.splice(index, 1);
    };

    $scope.AddTerminalToStaff = function() {
      var terminal = angular.copy($scope.data.staff_terminal);

      if (terminal && terminal.filter_list_type === 'register') {
        if (!$scope.staff.terminals) {
          $scope.staff.terminals = [];
        }
        var hasTerminal = $scope.staff.terminals.find(function(t) {
          return t.id === terminal.id;
        });
        if (!hasTerminal) {
          $scope.staff.terminals.push(terminal);
        } else {
          NotifyService.Warning('Terminal access business staff already exists', false);
        }
      }
      $scope.data.staff_terminal = {};
    };
    $scope.businessStaff = [];
    $scope.businessStaffSummary = undefined;
    $scope.params = {
      page: 1,
      count: 20,
      suspended: 'all'
    };

    $scope.table_cols = [
      {
        visible: true,
        data: [
          {
            value: 'name',
            text: 'Business staff name',
            visible: true,
            sorting: 'name'
          },
          {
            value: 'email',
            text: 'Business staff email',
            visible: true,
            sorting: 'email'
          },
          {
            value: 'phone',
            text: 'Business staff phone',
            visible: true,
            sorting: 'phone'
          },
          {
            value: 'comment',
            text: 'Business staff comment',
            visible: false,
            sorting: 'comment'
          }
        ]
      },
      {
        visible: true,
        data: [
          {
            value: 'terminal_title',
            text: 'Register or Salesperson name',
            visible: true
          }, {
            value: 'terminal_id',
            text: 'ID',
            visible: true
          }, {
            value: 'terminal_type',
            text: 'Operation mode',
            visible: true
          }
        ]
      },
      {
        visible: true,
        data: [
          {
            value: 'suspended',
            text: 'Business staff suspended',
            visible: true,
            sorting: 'suspended'
          },
          {
            value: 'created',
            text: 'Business staff created',
            visible: true,
            sorting: 'create'
          }
        ]
      },
      {
        visible: true,
        data: [
          {
            value: 'auth_code',
            text: 'Business staff auth code',
            visible: true
          }
        ]
      }
    ];

    var block_business_staff_list = blockUI.instances.get('business-staff-list'),
        block_business_staff_form = blockUI.instances.get('business-staff-form');

    initController();

    function initPageMode() {
      $scope._pageMode = 'show';

      if (isRouteMode('edit')) {
        $scope._pageMode = ($routeParams.hasOwnProperty('staffId')) ? 'edit' : 'show';
      } else if (isRouteMode('create')) {
        $scope._pageMode = 'create';
      }

    }

    function initController() {
      initPageMode();

      switch ($scope._pageMode) {
        case 'create':
          doCreate();
          break;

        case 'show':
          doShow();
          break;

        case 'edit':
          doEdit();
          break;
      }
    }

    function doShow() {
      $scope.staff = {};
      getBusinessStaff();
    }

    function doCreate() {
      block_business_staff_form.start();
      $scope.staff = {};
      block_business_staff_form.stop();
      // SelectService.getLPRList(function (LPR_LIST) {
      //     $scope.LPR_LIST = angular.copy(LPR_LIST);
      //     block_business_staff_form.stop();
      // });
      // $scope.LPR_LIST.unshift({title: $filter('translate')('All terminals'), id: '0', active: 1});
    }

    function doEdit() {
      $scope.staff = {};
      block_business_staff_form.start();

      BusinessStaffService.GetStaff($routeParams.staffId, function(success, data) {
        if (success) {
          $scope.staff = angular.copy(data);
        } else {
          location.path('/business-staff');
        }
        block_business_staff_form.stop();
      });
    }

    $scope.getBusinessStaff = getBusinessStaff;

    function getBusinessStaff() {
      block_business_staff_list.start();
      var params = angular.copy($scope.params);

      if (params.terminal) {
        if (params.terminal.id !== '0') {
          params.terminal_id = params.terminal.id;
        }

        delete params.terminal;
      }

      BusinessStaffService.GetsStaff(params, function(success, data) {
        if (success) {
          $scope.businessStaff = angular.copy(data.data);
          $scope.businessStaffSummary = angular.copy(data.summary);
        }

        block_business_staff_list.stop();
      });
    }

    $scope.onShowQR = function(staff) {
      $uibModal.open({
        animation: true,
        keyboard: true,
        size: 'md',
        templateUrl: 'app/pages/business-staff/modals/qr-code.modal.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;
          popup.staff = staff;

          popup.onPrint = function() {
            var printContents = document.getElementById('printable-qr').innerHTML,
                canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                popupWin = window.open('', '_blank',
                    'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

            printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

            popupWin.document.open();
            popupWin.document.write('<html><head><base href="/"><title></title>' +
                '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                '<body>' + printContents + '</body></html>');
            popupWin.focus();
            // setTimeout(function () {
            //     popupWin.document.execCommand('print');
            //     popupWin.print();
            //     popupWin.document.close();
            //     popupWin.close();
            // }, 10);
            var count = popupWin.document.querySelectorAll('img, link').length;

            function printOnLoad() {
              setTimeout(function() {
                popupWin.focus();
                popupWin.document.execCommand('print');
                // popupWin.print();
                popupWin.document.close();
                popupWin.close();
              }, 200);
            }

            if (count) {
              popupWin.document.querySelectorAll('img, link').forEach(function(el) {
                el.onload = function() {
                  if (!--count) {
                    printOnLoad();
                  }
                };
              });
            } else {
              printOnLoad();
            }
          };

          popup.onCancelClick = function() {
            $uibModalInstance.close();
          };
        }
      });
    };

    $scope.saveBusinessStaff = function(form, needClose) {

      if (!form.name.$valid) {
        form.name.$dirty = true;
        return;
      }

      var staff = angular.copy($scope.staff);

      if (staff.terminals) {
        staff.terminals = staff.terminals.map(function(terminal) {
          return {id: terminal.id};
        });
      }

      if (!staff.auth_code) {
        staff.auth_code = '';
      }

      if (form.$valid) {
        block_business_staff_form.start();

        var callbackResult = function(success, data) {
          if (success) {
            if (needClose) {
              $location.path('/business-staff');
            }
          }
          block_business_staff_form.stop();
        };

        if (isPageMode('create')) {
          BusinessStaffService.AddStaff(
              staff,
              callbackResult
          );
        } else {
          BusinessStaffService.UpdateStaff(
              $routeParams.staffId,
              staff,
              callbackResult
          );
        }

      }
    };

    $scope.isPageMode = isPageMode;

    function isPageMode(mode) {
      return mode === $scope._pageMode;
    }

    function isRouteMode(mode) {
      return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
    }

    $scope.onBusinessStaffExport = function(format) {
      var isExportStopped = false;
      $scope.modalExport = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/templates/modal.export.html',
        controllerAs: 'exportModal',
        controller: function($uibModalInstance) {
          $scope.exportModal = this;

          // Прогресс загрузки в процентах
          $scope.exportModal.exportProgress = 0.1;

          // Количество загруженных записей
          $scope.exportModal.downloadedDataCount = 0;

          // Все количество загружаемых записей
          $scope.exportModal.allDataCount = 0;

          // Признак - находится ли экспорт на паузе
          $scope.exportModal.isExportPaused = false;

          $scope.exportModal.onTogglePause = function() {
            $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
            if (!$scope.exportModal.isExportPaused) {
              exportRequest();
            }
          };

          $scope.exportModal.onStop = function() {
            isExportStopped = true;
            $scope.modalExport.close();
            if ($scope.exportModal.isExportPaused) {
              handleExportResults();
            }
          };

          $scope.exportModal.onExit = function() {
            $scope.exportModal.isExportPaused = true;
            block_business_staff_list.stop();
            $scope.data.isFilePreparing = false;
            $uibModalInstance.close();
          };
        }
      });

      $scope.data.isFilePreparing = true;
      block_business_staff_list.start();
      var params = angular.copy($scope.params);
      delete params.sorting;
      delete params.order;
      if (params.terminal) {
        if (params.terminal.id !== '0') {
          params.terminal_id = params.terminal.id;
        }

        delete params.terminal;
      }

      var tl = [];

      function generateFile() {
        var file_name = $rootScope.ENV.business.code + '_business_staff';

        var export_struct = [];
        for (var i in $scope.table_cols) {
          if ($scope.table_cols[i].visible) {
            for (var k in $scope.table_cols[i].data) {
              export_struct.push({
                text: $filter('translate')($scope.table_cols[i].data[k].text),
                value: $scope.table_cols[i].data[k].value
              });
            }
          }
        }

        var export_data = [];
        for (var i in tl) {
          var el = {};
          for (var k in export_struct) {
            var a, b;
            a = export_struct[k].text;

            switch (export_struct[k].value) {
              case 'created':
                b = $filter('date')(tl[i]['created'], 'mediumDate') + ' ' + $filter('date')(tl[i]['created'], 'mediumTime');
                break;
              case 'suspended':
                b = tl[i]['suspended'] === 1 ? $filter('translate')('Yes') : $filter('translate')('No');
                break;
              case 'terminal_title':
                b = [];
                if (tl[i]['terminals']) {
                  for (var y in tl[i]['terminals']) {
                    b.push((tl[i]['terminals'][y]['title'] || ' - '));
                  }
                }
                b = b.join('\n');
                break;

              case 'terminal_id':
                b = [];
                if (tl[i]['terminals']) {
                  for (var y in tl[i]['terminals']) {
                    b.push((tl[i]['terminals'][y]['id'] || ' - '));
                  }
                }
                b = b.join('\n');
                break;
              case 'terminal_type':
                b = [];
                if (tl[i]['terminals']) {
                  for (var y in tl[i]['terminals']) {
                    var tb = ' - ';
                    switch (tl[i]['terminals'][y]['type']) {
                      case 'register':
                        tb = $filter('translate')('TEXT_MODE_REGISTER');
                        break;
                      case 'steward':
                        tb = $filter('translate')('TEXT_MODE_STEWARD');
                        break;
                      case 'validator':
                        tb = $filter('translate')('TEXT_MODE_VALIDATOR');
                        break;
                      case 'prepaid-services':
                        tb = $filter('translate')('TEXT_MODE_PREPAID_SERVICES');
                        break;
                      case 'road-tanker-driver':
                        tb = $filter('translate')('TEXT_MODE_ROAD_TANKER_DRIVER');
                        break;
                      case 'kiosk':
                        tb = $filter('translate')('TEXT_MODE_KIOSK');
                        break;
                    }
                    b.push(tb);
                  }
                }
                b = b.join('\n');
                break;

              default:
                b = (tl[i][export_struct[k].value] === null) ? '' : $filter('translate')(tl[i][export_struct[k].value]);
            }
            el[a] = b;
          }
          export_data.push(el);
        }

        $scope.$evalAsync(function($scope) {
          $scope.data.isFilePreparing = false;
          block_business_staff_list.stop();
        });

        switch (format) {
          case 'XLSX':
            alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
            break;
          case 'XLS':
            alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
            break;
          case 'CSV':
            alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
            break;
        }
      }

      // Номер текущей страницы с записями для загрузки
      var currentPage = 0;

      // Загруженные значения для экспорта
      var exportValues = [];

      // Количество записей загружаемых за один запрос к серверу
      var partCount = 200;

      // Массив параметров для запросов к серверу
      var exportParams = ExportService.generateExportParams(params, $scope.businessStaffSummary.total_rows_count, partCount);

      // Получение следующего массива записей
      function downloadNextPage(exportParams, currentPage) {
        return new Promise(function(resolve) {
          getBusinessStaff(exportParams[currentPage]).then(function(resp) {
            exportValues = [...exportValues, resp];
            currentPage++;
            ExportService.calculateExportValuesCount($scope, exportValues, $scope.businessStaffSummary.total_rows_count);
            if (!isExportStopped
                && !$scope.exportModal.isExportPaused
                && exportParams[currentPage]) {
              downloadNextPage(exportParams, currentPage).then(function(response) {
                resolve(response);
              });
            } else {
              resolve({currentPage: currentPage});
            }
          });
        });
      }

      function exportRequest() {
        downloadNextPage(exportParams, currentPage).then(function(response) {
          currentPage = response.currentPage;
          if (isExportStopped || !exportParams[currentPage]) {
            $scope.modalExport.close();
            handleExportResults();
          }
        });
      }

      function handleExportResults() {
        var result = {};
        result.data = [];
        result.summary = {};
        exportValues.forEach(function(value) {
          result.data = result.data.concat(value.data);
          result.summary = value.summary;
        });
        tl = result.data;
        tl.forEach(function(item) {
          item.id = item.user_id;
        });
        generateFile();
      }

      function getBusinessStaff(params) {
        return new Promise(function(resolve) {
          BusinessStaffService.GetsStaff(params, function(success, response) {
            resolve(response);
          });
        });
      }

      exportRequest();
    };

    $scope.pager_count = [10, 20, 50, 100, 200];

    $scope.getTableHeaderClass = function(row) {
      return {
        'sorting': !!row.sorting,
        'sorting_asc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'asc',
        'sorting_desc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'desc'
      };
    };

    $scope.onSortOrderChange = function(row) {
      if (!row.sorting) {
        return;
      }
      if ($scope.params.sort === row.sorting)
        $scope.params.order = $scope.params.order === 'asc' ? 'desc' : 'asc';
      else
        $scope.params.order = 'asc';

      $scope.params.sort = row.sorting;
      getBusinessStaff();
    };
    $scope.pageChange = function() {
      getBusinessStaff();
    };

    $rootScope.$watch('LPR_LIST', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        var allTerminal = {
          title: $filter('translate')('All terminals'),
          id: '0',
          filter_list_type: 'register',
          active: 1
        };
        var LPR_LIST = newValue;
        if (newValue[0].id !== allTerminal.id) {
          LPR_LIST.unshift(allTerminal);
        }

        $scope.LPR_LIST = LPR_LIST;

        if (!$scope.params.terminal) {
          $scope.params.terminal = allTerminal;
        }
      }
    });

    $scope.withOutAllTerminal = function(item) {
      return item.id !== '0';
    };
    /**
     *
     * @param count
     */
    $scope.onCountChange = function(count) {
      $scope.params.page = 1;
      $scope.params.count = count;
      getBusinessStaff();
    };

  }
})();
